<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增权限"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="上级" prop="parent_id">
                <el-select v-model="ruleForm.parent_id" placeholder="请选择上级"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allAction"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="权限名称" prop="action_name">
                <el-input type="text" v-model="ruleForm.action_name" placeholder="请输入权限名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="关联功能" prop="module_id">
                <el-select v-model="ruleForm.module_id" placeholder="请选择关联功能"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allmenu"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" min="1" placeholder="请输入排序号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="是否显示" prop="showflg">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";

    export default {
        created() {
            if (this.$route.params.parent_id) {
                this.ruleForm.parent_id = this.$route.params.parent_id.toString()
            }
        },
        mounted() {
            this.getList()
            this.getActionList()
        },
        data() {
            return {
                allmenu: [], // 管理功能模块
                allAction: [],
                ruleForm: {
                    action_name: "",
                    id: "",
                    parent_id: "0",
                    module_id: "2",
                    sort: "99",
                    status: 1,
                },
                rules: {
                    action_name: [
                        {required: true, message: "请输入权限名称", trigger: "blur"},
                    ],
                    parent_id: [
                        {required: true, message: "请选择上级", trigger: "blur"},
                    ],
                    module_id: [
                        {required: true, message: "请选择管理功能", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择是否显示", trigger: "blur"},
                    ]
                },
                is_submit: false,
            };
        },
        methods: {
            // 获取所有菜单功能
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'getMenu',
                    params: {
                        action_menu: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let menu = [];
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        menu.push({
                            id: res.data.data.list[i].id,
                            name: res.data.data.list[i].module_name,
                        })

                        if (res.data.data.list[i].children) {
                            for (var j = 0; j < res.data.data.list[i].children.length; j++) {
                                if (j == res.data.data.list[i].children.length - 1) {
                                    menu.push({
                                        id: res.data.data.list[i].children[j].id,
                                        name: "│\xa0\xa0└\xa0\xa0"+res.data.data.list[i].children[j].module_name,
                                    })
                                } else {
                                    menu.push({
                                        id: res.data.data.list[i].children[j].id,
                                        name: '│\xa0\xa0├\xa0\xa0'+res.data.data.list[i].children[j].module_name,
                                    })
                                }
                            }
                        }
                    }

                    this.allmenu = menu
                });
            },
            // 获取所有权限
            getActionList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'getAdminAction',
                    params: {
                        add_action: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let menu = [];
                    let childLen = 0;
                    let list = res.data.data.list;
                    let childlist = null;
                    let child3list = null;
                    for (var i = 0; i < list.length; i++) {
                        menu.push({
                            id: list[i].id,
                            name: list[i].action_name,
                        })
                        // 二级
                        if (list[i].children) {
                            childlist = list[i].children;
                            for (var j = 0; j < childlist.length; j++) {
                                if (j == childlist.length - 1) {
                                    menu.push({
                                        id: childlist[j].id,
                                        name: "│\xa0\xa0└\xa0\xa0"+childlist[j].action_name,
                                    })
                                } else {
                                    menu.push({
                                        id: childlist[j].id,
                                        name: '│\xa0\xa0├\xa0\xa0'+childlist[j].action_name,
                                    })
                                }

                                if (childlist[j].children) {
                                    child3list = childlist[j].children;
                                    for (let k = 0; k < child3list.length; k++) {
                                        if (k == child3list.length - 1) {
                                            menu.push({
                                                id: child3list[k].id,
                                                name: "│\xa0\xa0│\xa0\xa0└\xa0\xa0"+child3list[k].action_name,
                                            })
                                        } else {
                                            menu.push({
                                                id: child3list[k].id,
                                                name: '│\xa0\xa0│\xa0\xa0├\xa0\xa0'+child3list[k].action_name,
                                            })
                                        }
                                    }
                                }

                            }
                        }
                    }

                    this.allAction = menu
                });
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
                // window.close()
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminSystemServices',
                            'method': 'addAdminAction',
                            'params': {
                                parent_id: this.ruleForm.parent_id,
                                action_name: this.ruleForm.action_name,
                                module_id: this.ruleForm.module_id,
                                status: this.ruleForm.status,
                                sort: this.ruleForm.sort,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    window.history.go(-1);
                                }
                            });
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        _that.is_submit = false;
                        return false;
                    }
                });
                this.is_submit = false;
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
